module.exports = __webpack_public_path__ + "static/img/nav.5a9893f5.svg";